import { SET_SUBSCRIPTIONS_PLANS, SET_CURRENCY } from './constants';

export const setSubscriptionsPlans = payload => ({ type: SET_SUBSCRIPTIONS_PLANS, payload });
export const setCurrency = payload => ({ type: SET_CURRENCY, payload });
